import { RepairabilityIndex } from "@/components/RepairabilityIndex/repairabilityIndex";

import { useProductPageContext } from "../../context/productPage.context";

export const ProductPageRepairabilityIndexContainer = () => {
    const { repairabilityIndex } = useProductPageContext();

    if (!repairabilityIndex) {
        return null;
    }

    return <RepairabilityIndex repairabilityIndex={repairabilityIndex} />;
};
